<ui-grid [data]="data$ | async"
         [selectable]="false"
         [loading]="loading$ | async">
    <ui-grid-column [sortable]="true"
                    [primary]="true"
                    [title]="'profile_login_attempts_grid_time' | translate"
                    width="30%"
                    sort="desc"
                    property="time">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #timeFormat
                           [matTooltip]="timeFormat?.dataset['title']"
                           [date]="entry.time"
                           contentType="relative">
            </ui-dateformat>
        </ng-template>
        <ui-grid-dropdown-filter [items]="intervals"
                                 [value]="intervalValueFor(Interval.Day)"
                                 method="ge">
        </ui-grid-dropdown-filter>
    </ui-grid-column>

    <ui-grid-column [title]="'profile_login_attempts_grid_result' | translate"
                    width="30%"
                    property="result">
        <ng-template let-index="index"
                     let-entry="data">
            <ng-container *ngLet="('LoginAttemptsResult_' + entry.result | translate) as resultText">
                <span [matTooltip]="resultText">
                    {{ resultText }}
                </span>
            </ng-container>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [sortable]="true"
                    [title]="'profile_login_attempts_grid_browser_info' | translate"
                    width="40%"
                    property="browserInfo">
    </ui-grid-column>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>

</ui-grid>
